
/**
 * Powermail
 */
$(document).ready(function() {

    var $powermailForm = $(".powermail_form");

    // window.Parsley.on("form:error", function() {
    //     $.fn.matchHeight._update();
    // });
    // window.Parsley.on("field:validated", function() {
    //     $.fn.matchHeight._maintainScroll = true;
    //     $.fn.matchHeight._update();
    //     $.fn.matchHeight._maintainScroll = false;
    // });


    // -------------------------------------------------------------------------
    // Uploadfelder schön machen
    // Replacer erstellen
    // -------------------------------------------------------------------------

    var $powermailFile = $powermailForm.find(".powermail_file");

    $powermailFile.each(function () {
        upload = $(this);
        var replacer = '<span class="file-upload-replacer" data-replacefor="' + $(upload).attr('id') + '">' + $(upload).data('replacer_addfile') + '</span>';
        $(this).hide();
        $(upload).before(replacer);
    });


    // Wenn sich am echten Dateifeld was ändert, dann ändere auch den Replacer
    $powermailFile.change(function() {

        var $replacer = $('.file-upload-replacer[data-replacefor=' + $(this).attr('id') + ']');
        var filepath  = $(this).val();

        if (filepath !== "") {
            filepath = filepath.replace('C:\\fakepath\\', '');
            $replacer.addClass('active');
        } else {
            filepath = $(this).data('replacer_addfile');
           $replacer.removeClass('active');
        }

        // Schreibt den Dateinamen in den Replacer
        $replacer.html(filepath);

    });


    // Click auf das Replacer Element
    $('.file-upload-replacer').click(function (e) {

        // Wenn bereits eine Datei gewählt ist, wird diese nur gelöscht
        if ($(this).hasClass('active')) {
            e.preventDefault();
            var filepath = $('#' + $(this).data('replacefor')).data('replacer_addfile');
            $(this).html(filepath);
            $('#' + $(this).data('replacefor')).val('');
            $(this).removeClass('active');
        }
        // Das Original Element wird angeklickt
        else {
            $('#' + $(this).data('replacefor')).click();
        }
    });



    // checkDSGVO($('.tx-powermail div[class*="roboter"] input.powermail_checkbox'));
    // $('.tx-powermail div[class*="roboter"] input.powermail_checkbox').change(function() {
    //     checkDSGVO($(this));
    // });
});

$(document).on('focus', '.powermail_fieldwrap input, .powermail_fieldwrap textarea, .powermail_fieldwrap select, .powermail_fieldwrap', function (e) {
    e.stopPropagation();
    var hasClass = $(this).parent().parent().hasClass('focus');
    if (!hasClass) $(this).parent().parent().addClass('focus');
    // console.log('fokusin');

    checkFileInputs();
});
$(document).on('focusout', '.powermail_fieldwrap input, .powermail_fieldwrap textarea, .powermail_fieldwrap select', function () {
    var val = $(this).val();
    if (val === '') $(this).parent().parent().removeClass('focus');

    // console.log('fokusout');
    checkFileInputs();
});
$(document).on('click', '.file-upload-replacer', function(e) {
    e.stopPropagation();
    checkFileInputs();

    var hasClass = $(this).parent().parent().hasClass('focus');
    if (!hasClass) $(this).parent().parent().addClass('focus');
    // console.log('fokusin-file');
});
$(document).on('change', '.powermail_fieldwrap_type_select select', function() {
    var hasClass = $(this).parent().parent().hasClass('focus');
    if (!hasClass) $(this).parent().parent().addClass('focus');

    // console.log('change triggered');
});

function checkFileInputs() {
    $('.file-upload-replacer').each(function() {
        var val = $(this).parent().find('input').val();
        if (val === '') $(this).parent().parent().removeClass('focus');
        // console.log(val);
    });
}

function checkDSGVO(elem) {
    // console.log(elem.prop('checked'));
    if (elem.prop('checked') === true) {
        $('.tx-powermail input[type="submit"]').removeClass('deactivated');
        $('.tx-powermail input[type="submit"]').prop('disabled', false);
        // console.log('checked');
    } else {
        $('.tx-powermail input[type="submit"]').addClass('deactivated');
        $('.tx-powermail input[type="submit"]').prop('disabled', true);
        // console.log('not check');
    }
}